export const isSufeExamClient = (): boolean => (
  /(?:^|\s)DauyanElectron\/\S+/.test(navigator.userAgent)
  && /(?:^|\s)DauyanExamPolicy\/SUFE(?:\s|$)/.test(navigator.userAgent)
);
